<div class="table-skeleton-container">
  <div *ngIf="actionMessage" class="action-indicator">
    <mat-progress-spinner diameter="32" mode="indeterminate" color="primary"></mat-progress-spinner>
    <span class="action-message">{{ actionMessage }}</span>
  </div>

  <div class="skeleton-card" [class.with-card-header]="showCardHeader">
    <div class="skeleton-card-header" *ngIf="showCardHeader">
      <div class="skeleton-title"></div>
      <div class="skeleton-subtitle"></div>
    </div>

    <div class="skeleton-table-wrapper">
      <table class="skeleton-table">
        <thead *ngIf="showHeader">
          <tr>
            <th *ngFor="let col of columnsConfig" [style.width]="col.width || 'auto'">
              <div class="skeleton-cell header-cell"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rowsArray">
            <td *ngFor="let col of columnsConfig" [style.width]="col.width || 'auto'">
              <ng-container [ngSwitch]="col.type">
                <ng-container *ngSwitchCase="'icon-text'">
                  <div class="skeleton-icon"></div>
                  <div class="skeleton-cell skeleton-text"></div>
                </ng-container>
                <ng-container *ngSwitchCase="'icon'">
                  <div class="skeleton-icon"></div>
                </ng-container>
                <ng-container *ngSwitchCase="'badge'">
                  <div class="skeleton-badge"></div>
                </ng-container>
                <ng-container *ngSwitchCase="'actions'">
                  <div class="skeleton-actions">
                    <div class="skeleton-action-btn"></div>
                    <div class="skeleton-action-btn"></div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="skeleton-cell skeleton-text"></div>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
